import { Suspense } from 'react';
import { Navigate, RouteProps } from 'react-router-dom';
import TradeMobile from './mobile/TradeMobile';
import { DesktopTradeFallback } from './trade/Fallback';

// Lazy load your components
import PortfolioPage from '@/pages/portfolio';
import ThemePage from '@/pages/theme';
import TradePage from '@/pages/trade';
import { RouteBasePath } from '@/types/routers';
import MobileBlocker from './MobileBlocker';
import Cosplay from './components/Cosplay';
import PageHelper from './components/PageHelper';
import PortfolioMobile from './mobile/PortfolioMobile';

const routers: Array<RouteProps> = [
  {
    path: 'cosplay/:impostorAddress',
    element: <PageHelper mobileComponent={<Navigate to="/trade" replace />} desktopComponent={<Cosplay />} />,
  },
  {
    path: 'theme',
    element: <ThemePage />,
  },
  {
    path: '/trade',
    element: (
      <Suspense fallback={<DesktopTradeFallback />}>
        <TradePage />
      </Suspense>
    ),
  },

  {
    path: '/trade/:chainShortName/:pairSymbol?',
    element: (
      <Suspense fallback={<DesktopTradeFallback />}>
        <TradePage />
      </Suspense>
    ),
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/portfolio/:tab',
    element: <PortfolioPage />,
  },
  {
    path: '/earn',
    element: (
      <Suspense fallback={<DesktopTradeFallback />}>
        <TradePage />
      </Suspense>
    ),
  },
  {
    path: '/earn/:chainShortName/:pairSymbol?',
    element: (
      <Suspense fallback={<DesktopTradeFallback />}>
        <TradePage />
      </Suspense>
    ),
  },
];

export { routers };

export const mobileRouters: Array<RouteProps> = [
  {
    path: 'cosplay/:impostorAddress',
    element: <Cosplay />,
  },

  {
    path: `${RouteBasePath.trade}/:chainShortName/:pairSymbol?`,
    element: <TradeMobile />,
  },
  {
    path: `${RouteBasePath.earn}/:chainShortName/:pairSymbol?`,
    element: <TradeMobile />,
  },

  {
    path: 'portfolio',
    element: <PortfolioMobile />,
  },
  {
    path: 'blocker',
    element: <MobileBlocker />,
  },
];
